import { API_URL } from '../config/api';
import assetResolver from '../utils/AssetResolver';

/** Resolve durable sample identities again when a session is reopened. */
export async function resolveInstrumentSampleUrl(zone, token) {
  if (zone.sourceType === 'stock') {
    return assetResolver.resolve({ sourceType: 'stock', assetId: zone.assetId || zone.bufferId, assetVersion: zone.assetVersion || 1 }, token);
  }
  if (zone.storageKey) {
    const response = await fetch(`${API_URL}/api/signed-url-by-key?key=${encodeURIComponent(zone.storageKey)}`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {}
    });
    if (!response.ok) throw new Error('Could not access the imported sample.');
    return (await response.json()).signedUrl;
  }
  return zone.url || null;
}
